(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.updateHeaderOnScroll = this.updateHeaderOnScroll.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this.header?.querySelector('.header-wrapper');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      
      // ✅ Check if homepage from data attribute
      this.isHomepage = this.getAttribute('data-is-homepage') === 'true';
      
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.setHeaderHeight();

      // ✅ If NOT homepage, make header white immediately
// ===== INITIAL HEADER STATE =====
if (this.headerWrapper) {
  if (this.isHomepage) {
    // Homepage MUST start transparent
    this.headerWrapper.classList.add('header-wrapper--transparent');
    this.headerWrapper.classList.remove('header-wrapper--scrolled');

    // Remove any inline background left by theme/previous state
    this.headerWrapper.style.removeProperty('background');
    this.headerWrapper.style.removeProperty('background-color');
    this.headerWrapper.style.removeProperty('box-shadow');

    // Make sure header is visible at the top
    this.header.classList.remove(
      'scrolled-past-header',
      'shopify-section-header-hidden'
    );

    // Homepage content should NOT be pushed down
    const nextSibling = this.header?.nextElementSibling;
    if (nextSibling) {
      nextSibling.style.paddingTop = '0px';
    }
  } else {
    // Other pages MUST start white
    this.headerWrapper.classList.remove('header-wrapper--transparent');
    this.headerWrapper.style.background = 'rgb(255, 255, 255)';
  }
}

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.header?.offsetHeight || 80;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0]?.intersectionRect || { top: 0, bottom: 0 };
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    updateHeaderOnScroll(scrollTop) {
      // ✅ Update content padding based on scroll
      const nextSibling = this.header?.nextElementSibling;
      if (nextSibling) {
        const headerHeight = this.header?.offsetHeight || 80;
        if (scrollTop > 50) {
          nextSibling.style.paddingTop = `${headerHeight + 20}px`;
        } else if (!this.isHomepage) {
          nextSibling.style.paddingTop = `${headerHeight + 20}px`;
        } else {
          nextSibling.style.paddingTop = '0px';
        }
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      // ✅ HOMEPAGE LOGIC
      if (this.isHomepage) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
      } 
      // ✅ OTHER PAGES LOGIC - Always sticky with white background
      else {
        const headerHeight = this.header?.offsetHeight || 80;
        const nextSibling = this.header?.nextElementSibling;
        
        if (scrollTop > 50) {
          this.header.classList.add('scrolled-past-header');
          if (nextSibling) {
            nextSibling.style.paddingTop = `${headerHeight + 20}px`;
          }
        } else {
          this.header.classList.remove('scrolled-past-header');
          if (nextSibling) {
            nextSibling.style.paddingTop = `${headerHeight + 20}px`;
          }
        }
      }

      this.currentScrollTop = scrollTop;
      this.updateHeaderOnScroll(scrollTop);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      
      // ✅ Reset padding on homepage when at top
      const nextSibling = this.header?.nextElementSibling;
      if (nextSibling) {
        nextSibling.style.paddingTop = '0px';
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // Account dialog positioning
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
